import type { UseFormReturn } from 'react-hook-form';

import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, Textarea } from '~/components/Form';

import type { ContactFormType } from '../types';

import { ContactFormSection } from './ContactFormSection';
import { gridStyle } from './contactFormSections.css';

type ContactCommentsFormType = Pick<ContactFormType, 'comments'>;

export const ContactCommentsFormSection = <T extends ContactCommentsFormType>({
  form: { control },
}: {
  form: T extends ContactCommentsFormType ? UseFormReturn<T> : never;
}) => {
  const { t } = useTranslation(['clients', 'common', 'validation']);

  return (
    <ContactFormSection
      description={t('clients:createEdit.subsections.comments.description')}
      title={t('clients:createEdit.subsections.comments.title')}
    >
      <div className={gridStyle}>
        <Controller
          control={control}
          name="comments"
          render={({ field: { name, onBlur, onChange, ref, value }, fieldState: { error, invalid, isDirty, isTouched } }) => (
            <Field.Root dirty={isDirty} invalid={invalid} name={name} touched={isTouched}>
              <Field.Label optional>{t('clients:createEdit.subsections.comments.fieldLabel')}</Field.Label>

              <Textarea
                onBlur={onBlur}
                onValueChange={onChange}
                placeholder={t('clients:fields.userComments.placeholder')}
                ref={ref}
                value={value ?? ''}
              />

              <Field.Footer>
                <Field.Description>{t('clients:createEdit.subsections.comments.fieldFootnote')}</Field.Description>
                <Field.Error match={!!error}>{error?.message}</Field.Error>
              </Field.Footer>
            </Field.Root>
          )}
        />
      </div>
    </ContactFormSection>
  );
};
